export enum ProspectTypeEnum {
  Individual = 1,
  Business = 2,
}

export const ProspectTypeStringEnum = {
  Individual: 'Individual',
  Business: 'Business'
};
